const globalCorporatePartner = () => {
  jQuery(document).ready(function($) {
    const heroSection = $('.section-global-corporate-partner-hero');
    if (heroSection.length) {
      const $imagesSlider = heroSection.find('.hero-images-slider');
      const slidesAutoplaySpeed = parseInt($imagesSlider.data('slides-autoplay-speed'), 10);
      const $contentItems = heroSection.find('.hero-contents-slider .hero-content-item');

      $imagesSlider.slick({
        arrows: true,
        dots: true,
        autoplay: slidesAutoplaySpeed > 0,
        autoplaySpeed: slidesAutoplaySpeed > 0 ? slidesAutoplaySpeed : undefined,
      });

      const updateHeroContent = function(index) {
        $contentItems.removeClass('active');
        $contentItems.eq(index).addClass('active');
      };

      // Initial state
      updateHeroContent(0);

      $imagesSlider.on('afterChange', function (event, slick, currentSlide) {
        updateHeroContent(currentSlide);
      });

      const heroButton = heroSection.find('.hero-button');
      if (heroButton.length) {
        heroButton.on('click', function(e) {
          e.preventDefault();

          const resultsSection = $('.section-global-corporate-partner-results');
          if (resultsSection.length) {
            resultsSection.goToElement();
          }
        });
      }
    }
  });
};

export default globalCorporatePartner;



// WEBPACK FOOTER //
// ./scripts/routes/modules/globalCorporatePartner.js